<script>
import user from '@/lib/user'

export default {
  methods: { ...user },
}
</script>
